exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._22-BOVUkBM3pMT28EIabJB {\n    margin-bottom: var(--content-padding);\n}\n", ""]);

// exports
exports.locals = {
	"with-bottom-margin": "_22-BOVUkBM3pMT28EIabJB",
	"withBottomMargin": "_22-BOVUkBM3pMT28EIabJB"
};